import React from 'react';

const GalleryItem = React.memo(({ imageName, onClick, onError }) => {
  return (
    <div 
      className="galleryItem"
      onClick={() => onClick(imageName)}
    >
      <img 
        src={`/mediaImages/${imageName}`} 
        alt={imageName}
        className="galleryImage"
        loading="lazy"
        onError={() => onError?.(imageName)}
      />
    </div>
  );
});

GalleryItem.displayName = 'GalleryItem';

export default GalleryItem;
